const style = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(10, 10, 15, 0.5)",
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modalContent: {
    background: "linear-gradient(145deg, #1A1F27, #101418)",
    borderRadius: "16px",
    border: "1px solid #30363D",
    width: "90%",
    maxWidth: "800px",
    boxShadow: "0 20px 40px -10px rgba(0, 0, 0, 0.7)",
    display: "flex",
    flexDirection: "column",
    maxHeight: "90vh",
  },
  modalHeader: {
    padding: "24px 28px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #30363D",
    flexShrink: 0,
  },
  modalTitle: {
    margin: 0,
    fontSize: "22px",
    fontWeight: 600,
    color: "#E6EDF3",
  },
  modalCloseButton: {
    background: "transparent",
    border: "none",
    color: "#8B949E",
    cursor: "pointer",
    fontSize: "24px",
  },
  modalBody: {
    padding: "24px 28px",
    flexGrow: 1,
    display: "flex",
    gap: "24px",
    overflowY: "auto",
  },
  editorContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  aiContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  label: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#8B949E",
    marginBottom: "8px",
    display: "block",
  },
  promptTextarea: {
    width: "100%",
    minHeight: "400px",
    backgroundColor: "#0D1117",
    border: "1px solid #30363D",
    borderRadius: "8px",
    color: "#E6EDF3",
    padding: "16px",
    fontSize: "15px",
    fontFamily: "inherit",
    lineHeight: 1.6,
    resize: "vertical",
    boxSizing: "border-box",
    outline: "none",
    flexGrow: 1,
  },
  generateButton: {
    backgroundColor: "#388BFD",
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    padding: "10px 16px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
  },
  resultContainer: {
    marginTop: "12px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  usePromptButton: {
    backgroundColor: "#238636",
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    padding: "8px 12px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    alignSelf: "flex-start",
  },
  modalFooter: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    padding: "20px 28px",
    borderTop: "1px solid #30363D",
    backgroundColor: "rgba(13, 17, 23, 0.5)",
    flexShrink: 0,
  },
  cardSubtext: {
    margin: "6px 0 0 0",
    fontSize: "14px",
    color: "#8B949E",
  },
  actionButton: {
    borderRadius: "8px",
    padding: "10px 20px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    border: "1px solid transparent",
  },
  saveButton: {
    backgroundColor: "#2DA44E",
    color: "#ffffff",
  },
  cancelButton: {
    backgroundColor: "transparent",
    color: "#8B949E",
    borderColor: "#30363D",
  },
};

export default style;
